import { get } from "../Config";


export function GetAllBanner() {
  return get({ url: `/api/impact/v1/allBanner` });
}

export function GetRestaurantId({ params }){
  return get({ url: `/api/impact/v1/restaurantIdByName`, params });
}